module.exports = __webpack_public_path__ + "img/errorred.282852c9.svg";